// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout for Consulta OC / Consulta Documentos filter panels */

.consultationFilters_filterShell__GvPg8 {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  padding: 0.65rem 1rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.04);
  overflow: visible;
}

.consultationFilters_filterShell__GvPg8 .consultationFilters_stack__w\\+j2b {
  gap: 0.5rem;
}

.consultationFilters_filterShell__GvPg8 .form-group {
  margin-bottom: 0 !important;
}

.consultationFilters_secondaryShell__oKKv\\+ {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  padding: 0.35rem 0.75rem;
  margin-bottom: 0.65rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04);
  color: #64748b;
  font-size: 0.8125rem;
  line-height: 1.25;
}

.consultationFilters_excelBtn__oCuuC {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.5rem;
  padding: 0.22rem 0.625rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  color: #475569;
  font-weight: 500;
  font-size: 0.8125rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.consultationFilters_excelBtn__oCuuC:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #0f172a;
}

.consultationFilters_inlineSearchInput__8T-v6 {
  border: 1px solid #e2e8f0 !important;
  border-radius: 6px !important;
  padding: 0.28rem 0.5rem !important;
  min-width: min(100%, 200px);
  max-width: 240px;
  height: 1.875rem;
  font-size: 0.8125rem !important;
  line-height: 1.25 !important;
  color: #334155 !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
}

.consultationFilters_inlineSearchInput__8T-v6:focus {
  outline: none !important;
  border-color: #818cf8 !important;
  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.18) !important;
}

.consultationFilters_filterShellCollapsed__FVgLl {
  padding-bottom: 0.55rem;
}

.consultationFilters_filterSectionHead__nTxqe {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.45rem;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #e2e8f0;
}

.consultationFilters_filterSectionHead__nTxqe .consultationFilters_sectionTitle__u2AtO {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
  flex: 1 1;
  min-width: 0;
}

.consultationFilters_filterCollapseToggle__j0oN1 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
}

.consultationFilters_filterCollapseToggle__j0oN1:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
}

.consultationFilters_filterCollapseToggle__j0oN1:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.35);
  border-color: #c7d2fe;
}

.consultationFilters_filterCollapseOuter__UP1Ec {
  display: grid;
  grid-template-rows: 1fr;
  transition: grid-template-rows 0.32s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: visible;
}

.consultationFilters_filterShellCollapsed__FVgLl .consultationFilters_filterCollapseOuter__UP1Ec {
  grid-template-rows: 0fr;
}

.consultationFilters_filterCollapseInner__ARNmj {
  overflow: hidden;
  min-height: 0;
  padding-top: 0;
  /* Al colapsar el grid usa 0fr: si hay padding-top aquí la franja conserva altura y se ven trozos de .floatingLabel (absolute). El espacio solo aplica expandido. */
  transition: padding-top 0.32s cubic-bezier(0.4, 0, 0.2, 1);
}

.consultationFilters_filterShell__GvPg8:not(.consultationFilters_filterShellCollapsed__FVgLl) .consultationFilters_filterCollapseInner__ARNmj {
  padding-top: 1rem;
  overflow: visible;
}

.consultationFilters_filterChevron__f9L0R {
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.consultationFilters_filterChevronCollapsed__TSXHi {
  transform: rotate(180deg);
}

.consultationFilters_sectionTitle__u2AtO {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
  margin-bottom: 0.45rem;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #e2e8f0;
}

.consultationFilters_grid__1iRPN {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.45rem 0.75rem;
  align-items: start;
}

.consultationFilters_gridWide__P7fA0 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.45rem 0.75rem;
  align-items: start;
}

@media (min-width: 1200px) {
  .consultationFilters_grid__1iRPN {
    grid-template-columns: repeat(4, 1fr);
  }

  .consultationFilters_gridWide__P7fA0 {
    grid-template-columns: repeat(5, 1fr);
  }
}

.consultationFilters_fullWidthRow__ixhqs {
  grid-column: 1 / -1;
  margin-top: 0.35rem;
  width: 100%;
}

/** Fila ítems/JSON + CONSULTAR (sin fila extra solo para el botón). */
.consultationFilters_filterSearchRow__1rBxk {
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.45rem 0.65rem;
  margin-top: 0.35rem;
  width: 100%;
}

.consultationFilters_filterSearchRowInput__5FLZa {
  flex: 1 1 min(100%, 260px);
  min-width: 0;
}

.consultationFilters_filterSearchRowBtn__ySb-a {
  flex: 0 0 auto;
}

.consultationFilters_actions__mzdsP {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  margin-top: 1rem;
  padding-top: 0.5rem;
}

.consultationFilters_stack__w\\+j2b {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.consultationFilters_fieldSpacer__VNUKF {
  min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/consultationFilters.module.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,+EAA+E;EAC/E,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,8EAA8E;EAC9E,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kFAAkF;AACpF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;EAClC,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd;;;oBAGkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iEAAiE;EACjE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mKAAmK;EACnK,0DAA0D;AAC5D;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA,sEAAsE;AACtE;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Layout for Consulta OC / Consulta Documentos filter panels */\n\n.filterShell {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n  padding: 0.65rem 1rem;\n  margin-bottom: 0.75rem;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.04);\n  overflow: visible;\n}\n\n.filterShell .stack {\n  gap: 0.5rem;\n}\n\n.filterShell :global(.form-group) {\n  margin-bottom: 0 !important;\n}\n\n.secondaryShell {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fff;\n  padding: 0.35rem 0.75rem;\n  margin-bottom: 0.65rem;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04);\n  color: #64748b;\n  font-size: 0.8125rem;\n  line-height: 1.25;\n}\n\n.excelBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 0.5rem;\n  padding: 0.22rem 0.625rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  background: #fff;\n  color: #475569;\n  font-weight: 500;\n  font-size: 0.8125rem;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.excelBtn:hover {\n  background: #f8fafc;\n  border-color: #94a3b8;\n  color: #0f172a;\n}\n\n.inlineSearchInput {\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 6px !important;\n  padding: 0.28rem 0.5rem !important;\n  min-width: min(100%, 200px);\n  max-width: 240px;\n  height: 1.875rem;\n  font-size: 0.8125rem !important;\n  line-height: 1.25 !important;\n  color: #334155 !important;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n}\n\n.inlineSearchInput:focus {\n  outline: none !important;\n  border-color: #818cf8 !important;\n  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.18) !important;\n}\n\n.filterShellCollapsed {\n  padding-bottom: 0.55rem;\n}\n\n.filterSectionHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.45rem;\n  padding-bottom: 0.35rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.filterSectionHead .sectionTitle {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n  flex: 1;\n  min-width: 0;\n}\n\n.filterCollapseToggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #475569;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.filterCollapseToggle:hover {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.filterCollapseToggle:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.35);\n  border-color: #c7d2fe;\n}\n\n.filterCollapseOuter {\n  display: grid;\n  grid-template-rows: 1fr;\n  transition: grid-template-rows 0.32s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: visible;\n}\n\n.filterShellCollapsed .filterCollapseOuter {\n  grid-template-rows: 0fr;\n}\n\n.filterCollapseInner {\n  overflow: hidden;\n  min-height: 0;\n  padding-top: 0;\n  /* Al colapsar el grid usa 0fr: si hay padding-top aquí la franja conserva altura y se ven trozos de .floatingLabel (absolute). El espacio solo aplica expandido. */\n  transition: padding-top 0.32s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.filterShell:not(.filterShellCollapsed) .filterCollapseInner {\n  padding-top: 1rem;\n  overflow: visible;\n}\n\n.filterChevron {\n  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.filterChevronCollapsed {\n  transform: rotate(180deg);\n}\n\n.sectionTitle {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n  margin-bottom: 0.45rem;\n  padding-bottom: 0.35rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 0.45rem 0.75rem;\n  align-items: start;\n}\n\n.gridWide {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 0.45rem 0.75rem;\n  align-items: start;\n}\n\n@media (min-width: 1200px) {\n  .grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  .gridWide {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n.fullWidthRow {\n  grid-column: 1 / -1;\n  margin-top: 0.35rem;\n  width: 100%;\n}\n\n/** Fila ítems/JSON + CONSULTAR (sin fila extra solo para el botón). */\n.filterSearchRow {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.45rem 0.65rem;\n  margin-top: 0.35rem;\n  width: 100%;\n}\n\n.filterSearchRowInput {\n  flex: 1 1 min(100%, 260px);\n  min-width: 0;\n}\n\n.filterSearchRowBtn {\n  flex: 0 0 auto;\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 0.75rem;\n  margin-top: 1rem;\n  padding-top: 0.5rem;\n}\n\n.stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.fieldSpacer {\n  min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterShell": `consultationFilters_filterShell__GvPg8`,
	"stack": `consultationFilters_stack__w+j2b`,
	"secondaryShell": `consultationFilters_secondaryShell__oKKv+`,
	"excelBtn": `consultationFilters_excelBtn__oCuuC`,
	"inlineSearchInput": `consultationFilters_inlineSearchInput__8T-v6`,
	"filterShellCollapsed": `consultationFilters_filterShellCollapsed__FVgLl`,
	"filterSectionHead": `consultationFilters_filterSectionHead__nTxqe`,
	"sectionTitle": `consultationFilters_sectionTitle__u2AtO`,
	"filterCollapseToggle": `consultationFilters_filterCollapseToggle__j0oN1`,
	"filterCollapseOuter": `consultationFilters_filterCollapseOuter__UP1Ec`,
	"filterCollapseInner": `consultationFilters_filterCollapseInner__ARNmj`,
	"filterChevron": `consultationFilters_filterChevron__f9L0R`,
	"filterChevronCollapsed": `consultationFilters_filterChevronCollapsed__TSXHi`,
	"grid": `consultationFilters_grid__1iRPN`,
	"gridWide": `consultationFilters_gridWide__P7fA0`,
	"fullWidthRow": `consultationFilters_fullWidthRow__ixhqs`,
	"filterSearchRow": `consultationFilters_filterSearchRow__1rBxk`,
	"filterSearchRowInput": `consultationFilters_filterSearchRowInput__5FLZa`,
	"filterSearchRowBtn": `consultationFilters_filterSearchRowBtn__ySb-a`,
	"actions": `consultationFilters_actions__mzdsP`,
	"fieldSpacer": `consultationFilters_fieldSpacer__VNUKF`
};
export default ___CSS_LOADER_EXPORT___;
